import React from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Routes, Route, Navigate } from "react-router-dom";
import PropTypes from "prop-types";

// Import Layouts
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import Routes & Middleware
import { layoutTypes } from "./constants/layout";
import { authProtectedRoutes, publicRoutes } from "./routes";
import Authmiddleware from "./routes/route";

// Import Global Components
import ApprovalPopup from "./components/ApprovalPopup"; 
// Hapus ToastContainer dan import CSS toastify di sini
import GlobalStatusModal from "./components/Common/GlobalStatusModal"; 

// Import Styles
import "./assets/scss/theme.scss";

// Fungsi pilih layout
const getLayout = (layoutType) => {
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      return VerticalLayout;
    case layoutTypes.HORIZONTAL:
      return HorizontalLayout;
    default:
      return VerticalLayout;
  }
};

const RouteWrapper = ({ Component, loadingFallback }) => (
  <React.Suspense fallback={loadingFallback}>
    <Component />
  </React.Suspense>
);

RouteWrapper.propTypes = {
  Component: PropTypes.elementType.isRequired,
  loadingFallback: PropTypes.element.isRequired,
};

const App = () => {
  const LayoutSelector = createSelector(
    (state) => state.Layout,
    (layout) => ({ layoutType: layout.layoutType })
  );

  const { layoutType } = useSelector(LayoutSelector);
  const Layout = getLayout(layoutType);

  const loadingFallback = (
    <div
      style={{
        height: "calc(100vh - 70px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <span className="spinner-border text-primary" role="status"></span>
      <p className="text-muted mt-2 ms-2">Memuat Halaman...</p>
    </div>
  );

  return (
    <React.Fragment>
      {/* ➡️ KOMPONEN GLOBAL */}
      <ApprovalPopup />
      
      {/* ➡️ MODAL STATUS GLOBAL: Pengganti Toast */}
      <GlobalStatusModal /> 

      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                <RouteWrapper Component={route.component} loadingFallback={loadingFallback} />
              </NonAuthLayout>
            }
            key={`public-${idx}`}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => {
          if (React.isValidElement(route.component)) {
            return (
              <Route
                path={route.path}
                element={route.component}
                key={`private-${idx}`}
              />
            );
          }
          return (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>
                    <RouteWrapper Component={route.component} loadingFallback={loadingFallback} />
                  </Layout>
                </Authmiddleware>
              }
              key={`private-${idx}`}
            />
          );
        })}

        <Route path="*" element={<Navigate to="/pages-404" replace />} />
      </Routes>

      {/* ➡️ ToastContainer DIHAPUS agar tidak ada lagi error removalReason */}
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;